// Resolve o destino REAL de um item de navegação cujo routeName é dinâmico,
// reusando os mesmos helpers da nav antiga (em @constants/navigation-routes) —
// assim o comportamento de clique fica IDÊNTICO entre as duas navegações.
import { DYNAMIC_ROUTE } from '@modules/navegacao-v2/utils/visible-modules'
import {
  comissoesRouteName,
  treasuryRouteName,
  consolidadorRouteName,
} from '@constants/navigation-routes'

/**
 * @param {Object} item        item da nav (pode ter item.dynamicRoute)
 * @param {Object} ctx
 * @param {Object} ctx.access      store.getters['parameters/show']
 * @param {Object} ctx.currentUser this.$currentUser()
 * @param {boolean} ctx.isCliente  contexto cliente (afeta o Consolidador e o skip)
 * @returns {string} rota destino; cai no item.routeName quando não é dinâmico
 *                   ou quando o resolvedor não encontra destino (mantém o padrão).
 */
export function resolveDynamicRoute(item, ctx = {}) {
  if (!item) return ''

  // Contexto cliente: módulos cuja entrada cai numa Visão Geral / Bem-vindo /
  // painel agregado pulam direto para a 1ª tela escopável pelo cliente. Só quando
  // o item está COM acesso — em upsell (noAccessIcon) mantemos a landing (que é a
  // própria página de cross-sell). Ver CLIENTE_SKIP_TO em navigation-modules.
  if (ctx.isCliente && item.clienteSkipTo && !item.noAccessIcon) {
    return item.clienteSkipTo
  }

  if (!item.dynamicRoute) {
    return item.routeName
  }
  const access = ctx.access || {}
  const currentUser = ctx.currentUser || {}

  if (item.dynamicRoute === DYNAMIC_ROUTE.COMISSOES) {
    return comissoesRouteName(access)
  }
  if (item.dynamicRoute === DYNAMIC_ROUTE.TREASURY) {
    return treasuryRouteName(currentUser, access) || item.routeName
  }
  if (item.dynamicRoute === DYNAMIC_ROUTE.CONSOLIDADOR) {
    return consolidadorRouteName({ access, isCliente: !!ctx.isCliente })
  }
  return item.routeName
}
